// Slovenské dvojče locale/cs/servicePage.js.
export default {
  order: 'Objednať servis',
  pricelist: 'Zobraziť cenník',
  warranty: 'Záruka na opravy',
  warrantySub: '10+ rokov praxe tímu',
  servicesHint: 'Od diagnostiky po náhradné diely',
  noFees: 'Bez skrytých poplatkov',
  bandMail: 'Napísať servisu',
  services: 'Čo ponúkame v rámci servisu',
  pricing: 'Orientačný cenník servisu',
  why: 'Prečo si vybrať náš servis?',
  freeRe: /zadarmo|zdarma/i,
};
